// Libraries
import { Center, Flex, Text } from '@chakra-ui/react';
// Components
import { BearingLogo, LogoType } from '@atoms/index';
// Utils
import text from '@translations/en.json';

/**
 * A component that displays an "empty state" message when no simulation results are available.
 *
 * @component
 * @returns {ReactElement} A UI block indicating that there are no simulation results to display.
 */
export const EmptyResults = () => {
  return (
    <Center w='full' minH={{ base: 57, md: 62.5 }}>
      <Flex direction='column' align='center'>
        <BearingLogo logoType={LogoType.ghost} w={31} h={7} />
        <Text color='grey.100' fontSize={{ base: 'l', md: 'xl' }} fontWeight='medium' mt={8} mb={4}>
          {text.cii_simulator.simulation_results_card.empty.title}
        </Text>
        <Text maxW={125} color='grey.100' textAlign='center' fontSize={{ base: 's', md: 'xl' }}>
          {text.cii_simulator.simulation_results_card.empty.description}
        </Text>
      </Flex>
    </Center>
  );
};
